import { COOKIES } from "../js/constants";
import Clicks from "./clicks";
import ContactForm from "./contact-form";
import ContactTestamentForm from "./contact-testament-form";
import DonationForm from "./donation-form";
import DonationFormEntryPoints from "./donation-form-entrypoints";
import Downloads from "./downloads";
import GiftCertificate from "./gift-certificate";
import InteractionEvents from "./interaction-events";
import MaterialForm from "./material-form";
import NavigationEvents from "./navigation-events";
import PromotionForm from "./promotion-form";
import ShareEvents from "./share-events";

export default class Tracking {
  /**
   * Creates all tracking instances
   */
  constructor() {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: "Page Meta",
      page_platform: "Drupal",
      nro: "Germany",
      office: "Germany",
    });

    this.clicks = new Clicks();
    this.contactForm = new ContactForm(
      ".Tracking--contactForm",
      COOKIES.CONTACT_FORM_START,
      COOKIES.CONTACT_FORM_SUBMISSION
    );
    this.contactForm = new ContactForm(
      ".Tracking--changeAddressForm",
      COOKIES.CHANGE_ADDRESS_FORM_START,
      COOKIES.CHANGE_ADDRESS_FORM_SUBMISSION
    );
    this.contactForm = new ContactForm(
      ".Tracking--changeFundingContributionForm",
      COOKIES.CHANGE_FUNDING_CONTRIBUTION_FORM_START,
      COOKIES.CHANGE_FUNDING_CONTRIBUTION_FORM_SUBMISSION
    );
    this.contactForm = new ContactForm(
      ".Tracking--addEmailAddressForm",
      COOKIES.ADD_EMAIL_ADDRESS_FORM_START,
      COOKIES.ADD_EMAIL_ADDRESS_FORM_SUBMISSION
    );
    this.contactForm = new ContactForm(
      ".Tracking--changeBankDetailsForm",
      COOKIES.CHANGE_BANK_DETAILS_FORM_START,
      COOKIES.CHANGE_BANK_DETAILS_FORM_SUBMISSION
    );
    this.contactTestamentForm = new ContactTestamentForm(
      ".Tracking--contactTestamentForm",
      COOKIES.CONTACT_TESTAMENT_FORM_START,
      COOKIES.CONTACT_TESTAMENT_FORM_SUBMISSION
    );
    this.donationForm = new DonationForm();
    this.donationFormEntryPoints = new DonationFormEntryPoints();
    this.downloads = new Downloads();
    this.giftCertificate = new GiftCertificate();
    this.interactionEvents = new InteractionEvents();
    this.materialForm = new MaterialForm();
    this.navigationEvents = new NavigationEvents();
    this.promotionForm = new PromotionForm();
    this.shareEvents = new ShareEvents();
  }
}
